import React from "react";
import { Notification } from "../Common/UI/Index";
import { checkIfOutputConfigMessageToDisplay } from "../RightPanel/OutputConfig/helper";
import { INotificationProps } from "./Notification.logic";

export interface INotificationViewProps extends INotificationProps {

  /**
   * Notification close callback
   */
  notificationClose: () => void;
}

type Props = INotificationViewProps;

/**
 * Responsible for rendering Notification View
 */
export const NotificationView: React.FC<Props> = (props: Props) => {
  const { notificationData, notificationClose } = props;
  const { actionType, id, type, text, title, closable } = notificationData;
  return (
    <div>
      {
        checkIfOutputConfigMessageToDisplay(actionType) && (
          <div data-testid={`extract-notification-${id}`}>
            <Notification
              className="ebt-notification__message"
              key={String(id)}
              variant={type ? type : "info"}
              title = {title}
              text={text}
              closable={closable}
              onClose={notificationClose} />
          </div>)
      }
    </div>
  );
};
